export enum QueryLangFilterOperator {
    /* SQL LIKE */
    LIKE = 'LIKE' ,

    /* Equal */
    EQ = 'EQ' ,

    /* Larger or Equal */
    LE = 'LE' ,

    /* Greater or Equal */
    GE = 'GE' ,

    /* Not Equal */
    NE = 'NE' ,

    /* Is Null */
    IS_NULL = 'IS_NULL' ,

    /* Is Not Null */
    IS_NOT_NULL = 'IS_NOT_NULL' ,

    /* In */
    IN = 'IN'
}

/**
 * [TRAD-195] Use start-with in security search on UI
 */
export enum QueryLangFilterOperatorExtension {
    STARTS_WITH = 'STARTS_WITH',
    ENDS_WITH   = 'ENDS_WITH'
}

export type QueryLangFilterOperatorExt = QueryLangFilterOperator | QueryLangFilterOperatorExtension;

export type QueryLangFilterUnaryOperator = QueryLangFilterOperator.IS_NULL
    | QueryLangFilterOperator.IS_NOT_NULL;

export type QueryLangFilterCriterionVariant<ITEM extends Record<string, any> = any> =
    [keyof ITEM, QueryLangFilterOperator, string]
    | [keyof ITEM, QueryLangFilterUnaryOperator];

export const isQueryLangFilterUnaryOperator = (
    operator: QueryLangFilterOperator
): operator is QueryLangFilterUnaryOperator =>
    operator === QueryLangFilterOperator.IS_NULL
    || operator === QueryLangFilterOperator.IS_NOT_NULL;

export const getQueryLangFilterCriterionVariant = (
    key: string,
    extOperator: QueryLangFilterOperatorExt,
    value: string
): QueryLangFilterCriterionVariant => {
    let operator: QueryLangFilterOperator;
    let rightArg: string;

    switch (extOperator) {
        case QueryLangFilterOperator.LIKE:
            operator = QueryLangFilterOperator.LIKE;
            rightArg = `%${value}%`;
            break;
        case QueryLangFilterOperatorExtension.STARTS_WITH:
            operator = QueryLangFilterOperator.LIKE;
            rightArg = `${value}%`;
            break;
        case QueryLangFilterOperatorExtension.ENDS_WITH:
            operator = QueryLangFilterOperator.LIKE;
            rightArg = `%${value}`;
            break;
        default:
            operator = extOperator;
            rightArg = value;
            break;
    }

    return isQueryLangFilterUnaryOperator(operator)
        ? [key, operator]
        : [key, operator, rightArg];
};
